import { inject, Injectable, signal } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { WhStateStore } from '../store/state.store';

export interface ClosableBottomsheet {
  requestClose(): void;
}

@Injectable({
  providedIn: 'root'
})
export class BottomsheetSvc {
  private stateStore = inject(WhStateStore);

  private currenSheet = signal<MatBottomSheetRef<any> | null>(null);

  register(ref: MatBottomSheetRef<any>) {
    this.currenSheet.set(ref);
    this.stateStore.showBackdrop();

    ref.afterDismissed().subscribe(() => {
      if (this.currenSheet() === ref) {
        this.currenSheet.set(null);
        this.stateStore.hideBackdrop();
      };
    })
  }

  closeIfOpened() {
    const ref = this.currenSheet();
    if (!ref) return false;

    const instance = ref.instance;

    if (instance && 'requestClose' in instance && typeof (instance as any).requestClose === 'function') {
      (instance as ClosableBottomsheet).requestClose();
    } else if (instance && 'close' in instance && typeof (instance as any).close === 'function') {
      (instance as any).close();
    } else {
      ref.dismiss();
    }

    return true;
  }

  hasOpened() {
    return !!this.currenSheet();
  }
}
